import {PsFeeRepository} from '@domain/model/PsFee/PsFeeRepository';
import {PsFee} from '@domain/model/PsFee/PsFee';
import {getAuthHeader} from '@infra/api/authManager/authManager';
import {DEFAULT_HEADERS} from '@infra/domain/model/_utils/defaultHeaders';
import {fetch} from '@infra/api/fetch';

export const HttpPsFeeRepository: PsFeeRepository = {
  getPsFeeInfo: async () => {
    const headers = {...DEFAULT_HEADERS, ...(await getAuthHeader())};
    const requestConfig = {
      method: 'GET',
      headers,
    };
    const response = await fetch('/web/api/payments/v1/psfee', requestConfig);
    if (!response.ok) {
      throw new Error('Failed to fetch PS fee information');
    }
    return (await response.json()) as PsFee;
  },
};
